import React from 'react';
import {Alert, AlertDescription, AlertIcon, AlertTitle, Box, Text} from '@chakra-ui/react';

const count = (value) => (Number.isFinite(value) ? value.toLocaleString('en-US') : null);

/**
 * Result of the workspace's latest import, kept visible after the job ends:
 * rows received/accepted/rejected and, when the plan refused new clients, how
 * many and why. A finished job used to show only "completed".
 */
export default function LatestImportOutcome({job}) {
    if (!job || job.status?.toLowerCase() !== 'completed') return null;
    const limit = job.customer_limit;
    const blocked = limit?.blocked_new_customers > 0;
    const received = count(job.received_rows);
    const accepted = count(job.accepted_rows);
    const rejected = count(job.rejected_rows);

    return (
        <Box mb={4} data-testid="latest-import-outcome">
            <Alert status={blocked ? 'warning' : 'info'} borderRadius="md" alignItems="flex-start">
                <AlertIcon />
                <Box>
                    <AlertTitle fontSize="sm">
                        Latest import{job.filename ? `: ${job.filename}` : ''}
                    </AlertTitle>
                    {received !== null && (
                        <AlertDescription fontSize="sm" display="block">
                            {received} rows received · {accepted ?? '–'} accepted · {rejected ?? '0'} rejected.
                        </AlertDescription>
                    )}
                    {blocked && (
                        <Text fontSize="sm" mt={1} data-testid="latest-import-capacity">
                            <strong>Plan client limit reached:</strong>{' '}
                            {limit.message || `${count(limit.blocked_new_customers)} new clients were not added.`}
                        </Text>
                    )}
                </Box>
            </Alert>
        </Box>
    );
}
